import { Injector } from '@angular/core';
import { Router } from '@angular/router';
import { AiAgentClientTool } from '@softapps/ai-agent';
import { base64Encode } from '@softline/core';
import { SalesStatisticsTemplate } from '../types/sales-statistics-template';
import {
  STATISTICS_FILTER_ARGS_SCHEMA,
  StatisticsFilterArgs,
  statisticsArgsToTemplate,
} from './agent-filter-mapping';
import { SalesStatisticsAgentBridge } from './sales-statistics-agent.bridge';

const DASHBOARD_ROUTE = '/sales-statistics/dashboard';

/** Opens the dashboard with the requested filters already applied. */
export const openSalesStatisticsTool: AiAgentClientTool<StatisticsFilterArgs> = {
  name: 'open_sales_statistics',
  description:
    'Öffnet das Umsatzstatistik-Dashboard und setzt dabei die angegebenen Filter.',
  parameters: STATISTICS_FILTER_ARGS_SCHEMA,
  async execute(args, injector) {
    const navigated = await navigateWithFilters(injector, statisticsArgsToTemplate(args ?? {}));
    return { navigated, route: DASHBOARD_ROUTE };
  },
};

/**
 * Changes the filters of the dashboard the user is looking at. Falls back to
 * opening it when they are somewhere else — the deep link applies once, strips
 * itself from the URL and triggers the label lookup.
 */
export const setStatisticsFilterTool: AiAgentClientTool<StatisticsFilterArgs> = {
  name: 'set_statistics_filter',
  description:
    'Ändert die Filter der Umsatzstatistik. Ist das Dashboard offen, wird direkt umgestellt, sonst wird es mit den Filtern geöffnet.',
  parameters: STATISTICS_FILTER_ARGS_SCHEMA,
  async execute(args, injector) {
    const patch = statisticsArgsToTemplate(args ?? {});
    if (injector.get(SalesStatisticsAgentBridge).applyPatch(patch))
      return { applied: true, navigated: false };
    const navigated = await navigateWithFilters(injector, patch);
    return { applied: navigated, navigated };
  },
};

function navigateWithFilters(
  injector: Injector,
  patch: Partial<SalesStatisticsTemplate>
): Promise<boolean> {
  return injector.get(Router).navigate([DASHBOARD_ROUTE], {
    queryParams: { chatbotFilters: base64Encode(JSON.stringify(patch)) },
  });
}
